import React from 'react';

import Button from '@ulta/core/components/Button/Button';

/**
 * Function for button action style
 * @function getButtonHtml
 * @param { object }  - returns an object with the appropriate HTML markup
 */
export const getButtonHtml = ( data ) => {
  const {
    action,
    actionStyle,
    derivedAriaLabel,
    fullyClickableParent,
    isKnockoutLink,
    textForScreenReaders
  } = data;

  /* Define button size based on actionStyle */
  const isButtonStyle = ['primary', 'secondary', 'teriary'].includes( actionStyle );
  const derivedButtonSize = isButtonStyle ? 'compact' : 'default';
  // const isButtonStyle = ( actionStyle === 'primary' || actionStyle === 'secondary' || actionStyle === 'tertiary' );

  /* Determine if the button needs a negative tab index */
  const hasNegIndex = ( !textForScreenReaders && fullyClickableParent );
  const updateTabIndex = hasNegIndex ? -1 : undefined;

  /* Determine if aria-label is needed */
  const needAriaLabel = !hasNegIndex && !textForScreenReaders;
  const updateAriaLabel = needAriaLabel ? derivedAriaLabel : undefined;

  return (
    <>
      <Button
        { ...action }
        action={ action } // We need to pass this specifically for the action to work with DC and everything else that comes with the web-site Button. Palette bundles this as one object and doesn't compose the action props the way web-site needs them. We did this this way to keep business logic out of Palette
        ariaLabel={ updateAriaLabel }
        fullyClickableParent={ fullyClickableParent }
        isKnockoutLink={ isKnockoutLink }
        screenReaderText={ derivedAriaLabel }
        size={ derivedButtonSize }
        tabIndex={ updateTabIndex }
        variant={ actionStyle }
      />
    </>
  );
};